var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { sampleFilePathMapping } from "../constants_map";
import { generateRandom } from "./MathHelpers";
import { downloadFile } from "SampleFileGeneration/file.generation";
import { fileContent } from "../SampleFileGeneration/GenerateFile.Helper";
export const getSampleFilePath = (mappingId, folderName) => {
    const fileName = sampleFilePathMapping[mappingId];
    let default_Val = 91;
    downloadFile({
        countryCode: folderName !== null && folderName !== void 0 ? folderName : default_Val,
        fileName: fileName,
        config: fileContent[mappingId]
    });
};
// export const getSampleFilePath = (mappingId, folderName) => {
//   const fileName = sampleFilePathMapping[mappingId];
//   console.log("getratesheet", mappingId, fileName, folderName);
//   if (!fileName) return `/samplefiles/${mappingId}`;
//   if (!folderName) return `/samplefiles/${fileName}`;
//   //alert(`File path: /samplefiles/${folderName}/${fileName}`);
//   return `/samplefiles/${folderName}/${fileName}`;
// };
export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0)
        return "0 Bytes";
    const k = 1024; // 1 KB = 1024 Bytes
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(decimals))} ${sizes[i]}`;
};
export const imageUrlToBase64 = (url, token) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield axios.get(url, {
            responseType: "blob",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        const blob = response.data;
        return new Promise((resolve, reject) => {
            try {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                    resolve(reader.result);
                };
            }
            catch (e) {
                reject(e);
            }
        });
    }
    catch (error) {
        console.error("There was an error fetching the image:", error);
        throw error;
    }
});
export function addNumberToFileName(fileName, number = Math.floor(generateRandom() * 10000)) {
    // Split filename into name and extension
    const dotIndex = fileName.lastIndexOf(".");
    if (dotIndex === -1) {
        // No extension — just append the number
        fileName = `${fileName}_${number}`;
    }
    const name = fileName.slice(0, dotIndex);
    const extension = fileName.slice(dotIndex); // includes the dot, e.g. ".jpg"
    fileName = `${name}_${number}${extension}`;
    return fileName;
}
